import { parseCardId } from "@/content/cards"
import { FAMILIES } from "@/content/families"
import { colors } from "@/theme/colors"
import type { CardId } from "@/types"
import type { FamilyNumber } from "@/theme/colors"

/*
 * The colour and the family label a card id resolves to.
 *
 * Every card surface — the deal, the spread, the board, the deep-dive strip, the
 * browser, the report — needs the same three values off the same id, so the
 * lookup lives once here rather than being re-derived per screen.
 *
 * Family 1 is the fallback rather than a throw: a card id is stored data, and a
 * document written against a deck that has since been re-cut must still paint.
 */

export interface CardTint {
  family: FamilyNumber
  /** The card's ground. */
  tint: string
  /** Text and hairlines on that ground. */
  ink: string
  /** The family's saturated accent, for dots and rules away from the card. */
  bloom: string
  /** Short family name, as the eyebrow prints it. */
  short: string
}

export function cardTint(id: CardId): CardTint {
  const parsed = parseCardId(id)
  const found = parsed ? FAMILIES.find((family) => family.n === parsed.family) : undefined
  const family = found?.n ?? 1
  const palette = colors.family[family]

  return {
    family,
    tint: palette.tint,
    ink: palette.ink,
    bloom: palette.bloom,
    short: found?.short ?? "",
  }
}
